const firebaseConfig = {
    apiKey: "AIzaSyBwCzYTkufgHbBEvAi2w1RFsor7C8cfbEo",
    authDomain: "safer-streets-riders.firebaseapp.com",
    projectId: "safer-streets-riders",
    storageBucket: "safer-streets-riders.appspot.com",
    messagingSenderId: "1027784265715",
    appId: "1:1027784265715:web:7197a7ec1469ba2cf44c86"
  };

  export default firebaseConfig